import { AuthGuard } from "../../shared/guards/AuthGuard";
import { Sidebar } from "../../shared/components";
import { AgreementsDetailsPresentation } from "./components/AgreementsDetailsPresentation";

export const AgreementsDetailsPage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<AgreementsDetailsPresentation />
			</Sidebar>
		</AuthGuard>
	);
};
